createApp({
  setup() {
    const current = reactive({
      category: 0
    })
    const pageData = ref(
      [
        {
          title: 'Dash Covers',
          featuresType: 1,
          template: 1,
          brandList: [
            {
              title:'Dash Designs™',
              img:'https://cdn.shopify.com/s/files/1/1961/1987/files/Dash-Designs.jpg?v=1721875007',
            },
            {
              title:'Dash Topper™',
              img:'https://cdn.shopify.com/s/files/1/1961/1987/files/Dash-Topper.jpg?v=1721875007',
            }
          ],
          download: 'https://www.dashdesigns.com/file/31473-Dashcovers+Instructions.pdf',
          video:'https://www.youtube.com/embed/FC6XE7w-cp0?si=eBVY-p4mhzc4yTHi',
          child: [
            {
              title: 'Poly Carpet',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Carpet.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '66.95',
                  url: '/pages/dash-designs-carpet-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '66.95',
                  url: '/pages/dash-toppers-carpet-dash-covers',
                }
              ],
              description: 'With our famous lifetime warranty, Poly Carpet™ is made from durable Eco-Fi material from recycled materials and available in nine colors that complement the interior of any vehicle. Poly Carpet™ helps you save money and the Environment! Our industry-leading precision patterns and hand-finished attention to detail offer beautiful protection for your dash with a truly custom fit.',
              features: [
                "Famous Lifetime Warranty","Made from Recycled Materials","Available in 9 Great Colors","Tough and Beautiful","Precision Patterns and Sewing for a Perfect Fit","Quick, Easy Installation","Easy To Clean and Maintain","Made In The USA"
              ]
            },
            {
              title: 'Plush Velour',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Plush_Velour.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '66.95',
                  url: '/pages/dash-designs-plush-velour-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '66.95',
                  url: '/pages/dash-toppers-plush-velour-dash-covers',
                }
              ],
              description: 'Plush Velour™ is a velvety soft material with a short silky nap that catches the light beautifully. This luxurious fabric is available in a range of gorgeous colors that make it the perfect choice for any vehicle.',
              features: [
                'Luxurious Velveteen Fabric That Won\'t Fade',
                'Available in 16 Beautiful Colors',
                'Precision Patterns and Sewing for a Perfect Fit',
                'Quick, Easy Installation',
                'Easy To Clean and Maintain',
                'Made In The USA', '5 Year Warranty'
              ]
            },
            {
              title: 'Brushed Suede',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Brushed-Suede.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '73.95',
                  url: '/pages/dash-designs-sedona-suede-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '73.95',
                  url: '/pages/dash-toppers-brushed-suede-dash-covers',
                }
              ],
              description: 'Here\'s a material that wears as well as it looks. Available in Black plus five beautiful earth tone colors, Brushed Suede™ is one of our most popular choices. This fabric also has excellent anti-glare qualities and is backed up with a 5-year warranty against defects in materials or workmanship. Brushed Suede™ is not only a great choice, it’s an outstanding value!',
              features: [
                'Distinctive Suede Fabric That Won\'t Fade',
                'Available in 6 Beautiful Earth Tone Colors',
                'Precision Patterns and Sewing for a Perfect Fit',
                'Quick, Easy Installation',
                'Easy To Clean and Maintain',
                'Made In The USA', '5 Year Warranty'
              ]
            },
            {
              title: 'Sedona Suede',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Sedona_Suede.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '76.95',
                  url: '/pages/dash-designs-sedona-suede-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '76.95',
                  url: '/pages/dash-toppers-sedona-suede-dash-covers',
                }
              ],
              description: 'Sedona Suede™ is an elegant dash cover fabric available in black and 5 beautiful earth tones. With its unique perforated texture, Sedona Suede™ offers a premium look and feel without the premium price.',
              features: [
                "Excellent Glare Reduction", "Available in 6 Great Colors", "Unique Perforated Style", "Precision Patterns and Sewing for a Perfect Fit", "Quick, Easy Installation", "Easy To Clean and Maintain", "Made In The USA", "5 Year Warranty"
              ]
            },
            {
              title: 'DashTex',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Dashtex.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '73.95',
                  url: '/pages/dash-designs-dashtex-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '73.95',
                  url: '/pages/dash-toppers-dashtex-dash-covers',
                }
              ],
              description: 'Available in four colors, Dashtex™ is one of our most popular choices, striking a great balance between appearance, durability and value. Dashtex™ offers a subtle sculpted pattern, giving it a rich, sophisticated look.',
              features: [
                "Excellent Glare Reduction", "Available in 4 Great Colors", "Unique Woven Pattern", "Precision Patterns and Sewing for a Perfect Fit", "Quick, Easy Installation", "Easy To Clean and Maintain", "Made In The USA", "5 Year Warranty"
              ]
            },
            {
              title: 'Camo',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Camo.jpg?v=1721804086',
              priceList: [
                {
                  vendor:'Dash Designs™',
                  price: '73.95',
                  url: '/pages/dash-designs-camo-dash-covers',
                },
                {
                  vendor:'Dash Topper™',
                  price: '73.95',
                  url: '/pages/dash-toppers-camo-dash-covers',
                }
              ],
              description: 'Our superb camouflage-style dashboard fabric has always been a hit with outdoor enthusiasts and their vehicles. TrueTimber® Kanati™ and DRT™ are premium materials that are as tough and as durable as the environments that they will be driven in and provide protection that really stands out.',
              features: [
                "Available in 2 TrueTimber® Outdoor Patterns", "Precision Patterns and Sewing for a Perfect Fit", "Quick, Easy Installation", "Easy To Clean and Maintain", "Made In The USA", "5 Year Warranty"
              ]
            }
          ]
        },
        {
          title: 'Seat Covers',
          featuresType: 1,
          template: 1,
          download:'https://www.dashdesigns.com/file/31485-Seat+Designs+Instructions.pdf',
          video:'https://www.youtube.com/embed/Bi-lDfQR5JI?si=J3ogKTj-JH2CCOpZ',
          child: [
            {
              title: 'Scottsdale™',
              url:'/pages/seat-designs-scottsdale-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Scottsdale.jpg?v=1721812012',
              price: '162.31',
              description: 'One of our all-time customer favorites, Scottsdale™ offers a unique blend of premium styling along with one of the very finest sculpted plush fabrics available today. Similar to Allure™ but with subtle pink and blue thread accents that really give it a distinctive appearance. Choose from 6 soft beautiful colors to compliment virtually any vehicle with these incredibly luxurious looking seat covers.',
              features: [
                "Sculpted Plush Fabric With Pink and Blue Accents", "Velvety Soft and Luxurious", "3/8 Inch Thick Foam Backing For Added Comfort", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Allure™',
              url:'/pages/seat-designs-allure-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Allure.jpg?v=1721812012',
              price: '216.95',
              description: 'Allure™ is one of our newest fabric selection. This material looks as beautiful and feels as elegant as its name. This sculpted plush velour is available in 4 colors and sets a new standard for comfort and elegance. Allure™ seat covers will enhance the looks and comfort of any vehicle.',
              features: [
                "Ultra Soft Sculpted Velour-Like Plush Fabric", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Looks and Feels Like The OEM Seat Fabric", "Made In The USA", "2 Year Warranty"
              ]
            },
            // {
            //   title: 'Madera™',
            //   url:'/pages/seat-designs-madera-seat-covers',
            //   image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Madera.jpg?v=1721812012',
            //   price: '216.95',
            //   description: 'This shimmering soft velour material has a subtle striped pattern and the overall look and feel is very distinctive. Available in 3 earth-tone shades, Madera™ is finished out with our quilted full-foam backing for incredible comfort. Our precise CAD-CAM manufacturing processes help to give Madera™ a truly fitted and very classic appearance to enhance the interior of most any vehicle.',
            //   features: [
            //     "Plush Velvety Fabric with a Subtle Striped Design", "Available in 3 Beautiful Colors", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
            //   ]
            // },
            {
              title: 'Plush Regal™',
              url:'/pages/seat-designs-plush-regal-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Plush-Regal.jpg?v=1721812012',
              price: '216.95',
              description: 'Our very plush, luxurious velour fabric has the look and feel of original factory seats. The subtle pattern of this material is specially woven to be super-soft, yet it\'s strong and durable enough to provide long lasting beauty. With a 3/8” thick quilted foam backing, Plush Regal™ is a classic and comfortable choice.',
              features: [
                "Plush Velvety Fabric with a Subtle Checkered Design", "Available in 4 Beautiful Colors", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Plush Velour',
              url:'/pages/seat-designs-plush-velour-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Plush-Velour.jpg?v=1721812012',
              price: '216.95',
              description: 'Plush Velour™, one of our new fabric selections, feels as beautiful and elegant as its name. With the looks of a durable quilted velour and the finish of a 100% Polyester blend, Plush Velour™ has been crafted to replicate automotive grade standards. It\'s all about the comfort ... so come feel the difference with Plush Velour™ quality seat covers from Seat Designs®.',
              features: [
                "Ultra Soft Velour Material", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Looks and Feels Like The OEM Seat Fabric", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Duramax Tweed™',
              url: '/pages/seat-designs-duramax-tweed-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Duramax-Tweed.jpg?v=1721812012',
              price: '216.95',
              description: 'As the name implies, this very durable heavy tweed fabric will provide all of the seat protection you will ever need. Duramax Tweed™ is now available in 8 great colors, and our industry leading 3/8" thick quilted full foam backing provides truly outstanding comfort and real value.',
              features: [
                "Durable Woven Fabric", "Foam Backing For Added Comfort", "Easy To Install", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'GrandTex™',
              url:'/pages/seat-designs-grandtex-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Grand-Tex.jpg?v=1721812012',
              price: '233.95',
              description: 'GrandTex™ is one of the most popular fabrics from our Designer™ series. This soft woven fabric has a subtle textured pattern that’s beautiful, comfortable and very durable. GrandTex™ seat covers are available in 5 beautiful solid or 2-tone styles to compliment and upgrade any vehicle interior.',
              features: [
                "Unique Textured Woven Fabric", "Available in Solid or 2-Tone Styles", "Warm in Winter and Cool in Summer", "Foam Backing For Added Comfort", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Cool Mesh™',
              url:'/pages/seat-designs-cool-mesh-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Cool-Mesh.jpg?v=1721812011',
              price: '233.95',
              description: 'This is our amazing \'Spacer Knit\' fabric with a specially woven \'breathable\' diamond-mesh to keep your vehicle seats and your backside cool and comfortable. Cool Mesh™ Seat Covers are the only seat covers designed to work with ventilated and air conditioned seats. Cool Mesh™ fabric seat covers are available in 4 great colors along with a matching reinforced side material to insure extra-long wear with a beautiful fit and finish.',
              features: [
                "Unique Breathable Spacer Knit Fabric", "Warm in Winter and Cool in Summer", "Foam Backing For Added Comfort", "Made In The USA", "2 Year Warranty"
              ]
            },
            // {
            //   title: 'Highland™',
            //   price: '233.95',
            //   description: 'Highland™ is our newest fabric selection. This durable woven plaid pattern is available in three 2-tone colors, evoking feelings reminiscent of the Scottish Highlands, while setting a new standard for comfort and elegance. Highland™ seat covers will enhance the looks and comfort of any vehicle.',
            //   features: [
            //     "Durable Woven Plaid Fabric", "Available as 2-Tone Only", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
            //   ]
            // },
            {
              title: 'Genuine Neoprene™',
              url:'/pages/seat-designs-genuine-neoprene-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Genuine-Neoprene.jpg?v=1721812012',
              price: '269.95',
              description: 'Genuine Neoprene™ Custom-Fit Seat Covers are available in 6 solid colors or 2-tone with black side panels and crafted with the same waterproof Nylon-bonded material used to make wet suits. If your vehicle\'s seats need the ultimate protection, this amazing waterproof fabric will protect them just like a wet suit!',
              features: [
                "Same Genuine Neoprene Used in Wet Suits", "Waterproof and Extremely Durable", "Available in Solid or 2-Tone Styles", "Laminated Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'NeoSupreme™',
              url:'/pages/seat-designs-neosupreme-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/NeoSupreme-2.jpg?v=1721812011',
              price: '233.95',
              description: 'Our ultimate lifestyle seat cover is crafted from a water-repellant, UV-resistant and Nylon-bonded 3mm NeoSupreme™ material. Available in 7 solid or 2-tone color combinations with black side panels, it’s sure to compliment any vehicle interior. Digital CAD-CAM patterns ensure a great fit and a laminated foam backing provides super-soft comfort.',
              features: [
                "Water-Resistant and Extremely Durable", "Available in Solid or 2-Tone Styles", "Laminated Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Kingston™',
              url:'/pages/seat-designs-kingston-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Kingston.jpg?v=1721812012',
              price: '232.95',
              description: 'Kingston™ is a resilient fabric that combines durability with good looks and comfort. Even though it is a rugged heavy duty material like the Cordura or Carhartt fabrics, Kingston™ fits great without the loose baggy look you might expect, and is really comfortable. It\'s extremely tough and durable to provide maximum protection for your vehicle’s seats.',
              features: [
                "Our Most Durable Fabric", "Water Resistant", "Tear Resistant", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Camo',
              price: '233.95',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Cowboy-Camo.jpg?v=1721812012',
              description: 'TrueTimber® natural camouflage patterns well as our Digital and Cowboy Camo™ seat covers provide premium styling with the rugged utility demanded by all outdoor enthusiasts. Available in Solid or 2-Tone styles, these super-tough water-resistant NeoSupreme™ fabrics will insure that your vehicle\'s seats will always be protected from daily hazards with stylish good looks and comfort.',
              features: [
                "Camo Patterns To Match Any Outdoor Lifestyle", "Beautiful High-Quality Prints That Won't Fade", "Durable NeoSupreme™ Water-Resistant Fabric", "Foam Backing For Added Comfort", "Available in Solid or 2-Tone Styles", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Southwest Sierra™',
              url:'/pages/seat-designs-southwest-sierra-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Southwest-Sierra.jpg?v=1721812012',
              price: '233.95',
              description: 'Our super durable tweed fabric comes in 7 exciting color combinations to make the ultimate statement in a handsome Southwestern motif. These colorful saddle blanket style materials are as tough and road worthy as they are beautiful. Our 3/8" thick quilted foam backing provides for a great custom fit with good looks and a very comfortable feel.',
              features: [
                "Durable Woven Fabric", "Beautiful Southwestern Designs", "Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            },
            {
              title: 'Hawaiian',
              url:'/pages/seat-designs-hawaiian-pattern-seat-covers',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/Hawaiian-Pattern.jpg?v=1721812012',
              price: '233.95',
              description: 'Enjoy the feel of the tropics right inside your own vehicle. Our beautiful Hawaiian-themed NeoSupreme™ printed fabric is an advanced water-resistant material available in a variety of vibrant patterns and colors in solid or 2-tone styles. Our durable quilted foam backings will provide a custom \'tropi-cool\' look to virtually any set of seats.',
              features: [
                "Beautifully Printed NeoSupreme™ Fabric", "Water-Resistant and Extremely Durable", "Available in Solid or 2-Tone Styles", "Laminated Foam Backing For Added Comfort", "Easy To Clean and Maintain", "Made In The USA", "2 Year Warranty"
              ]
            }
          ]
        },
        {
          title: 'Sun Shades',
          featuresType: 2,
          template: 2,
          download:'https://www.dashdesigns.com/file/23441-Original+Shade+Instructions.pdf',
          video:'https://www.youtube.com/embed/gKErCXFC6aI?si=cmOiUcD2JSyR0v0G',
          child: [
            {
              title: 'The Original Retractable Shade™',
              image: 'https://ca-auto-parts.myshopify.com/cdn/shop/files/Dash-Designs-Sun-Shades_1024x1024.png',
              url:'/pages/dash-designs-original-retractable-windshield-shades',
              price: '53.95',
              description: "Featuring easy, one-handed opening and closing, the Original Retractable Shade™ is the fastest and most convenient solution to block the sun's heat and UV rays to protect your vehicle’s interior. The patented pleated design features a reflective silver material that offers unmatched heat and UV protection for your vehicle. The Shade™ comes in sizes to fit most vehicles and installs in minutes. Keep your parked vehicle up to 50 degrees cooler and protect the interior from the sun's heat and UV rays at the same time! Remember, the Original Retractable Shade™ is also available as Metallic Red, Metallic Blue, or 6 beautiful prints.",
              features: [
                "Easy One-Handed Operation", "Retracts Into Slim Housing When Not in Use", "No Rolling, Folding, or Awkward Storage", "So Easy You'll Use It Every Time You Park", "The Original Retractable Shade Logo Pattern", "Sizes to Fit Most Vehicles", "Quick, Easy Installation", "Easy To Clean and Maintain", "2 Year Warranty"
              ]
            },
          ]
        },
        {
          title: 'FLOOR MATS',
          featuresType: 2,
          template: 2,
          features:[
            {
              image: 'https://cdn.shopify.com/s/files/1/1961/1987/files/Floor_Mat_Features.jpg?v=1721889698',
              title: 'Floor Mat Features',
              description: 'Endura® Custom Floor Mats are made from top quality cut-pile nylon fabric. The perfect choice to replace your OEM floor mats. Available in 9 different colors to match your vehicles interior.',
            },
            {
              image: 'https://cdn.shopify.com/s/files/1/1961/1987/files/Custom_Fit.jpg?v=1721889698',
              title: 'Custom Fit',
              description: 'The Endura® Mat is custom-fit to the make and model of your vehicle, so it accommodates all the unique curves and features for a precise fit.',
            },
            {
              image: 'https://cdn.shopify.com/s/files/1/1961/1987/files/Non-Slip_Backing.jpg?v=1721889698',
              title: 'Non-Slip Backing',
              description: 'The nibbed rubber backing of an Endura® Custom Floor Mat is designed to be non-slip, so you don\'t have to worry about them sliding out of place. Steel Grommets added when applicable to add an additional level of security.',
            }
          ],
          child: [
            {
              title: 'Endura® Mat Custom Floor Mats',
              image:'https://cdn.shopify.com/s/files/1/1961/1987/files/FLOOR_MATS.jpg?v=1721889698',
              url:'/pages/dash-designs-endura-custom-fit-carpet-floor-mats',
              price: '53.95',
              description: "Endura® Custom Floor Mats protect and enhance your factory carpet floors with the lush look and feel of cut pile nylon carpet. These premium floor mats are tailored to precisely fit the floors of your specific car, truck, van or SUV using digital CAD/CAM technology. Available in a range of beautiful colors, Endura® Floor Mats are equipped with non-slip rubber nib backing and factory-compatible grommets for added security. Upgrade your vehicle today with Endura® Custom Floor Mats!",
              features: [
                "100% cut-pile nylon with reinforced binding","Range of colors to customize your vehicle","Custom fit for cars, trucks, vans or SUVs","Tailored to precisely fit your specific vehicle","Non-slip rubber nibs keep your mats in place","Available in Front Sets, 2 Row Sets, 3 Row Sets and Cargo Mats."
              ]
            },
          ]
        },
        {
          title: 'STEERING WHEEL COVERS',
          featuresType: 2,
          template: 2,
          video:'https://www.youtube.com/embed/XuZ5AL7qARU?si=3nOzACpsHtpaNd-V',
          child: [
            {
              title: 'STEERING WHEEL COVERS',
              image: 'https://cdn.shopify.com/s/files/1/1961/1987/files/STEERING_WHEEL_COVERS.jpg?v=1721892469',
              url:'/pages/dash-designs-comfort-grip-steering-wheel-covers',
              price: '36.01',
              description: "The Dash Designs premium line of steering wheel covers are available in four different sizes to fit most steering wheels. With 14 beautiful styles you’re guaranteed to find a cover that will complement your vehicle’s interior and enhance your driving experience. Additionally, Comfort Grips™ will keep your steering wheel warm in winter and cool in summer. Get your hands on a Comfort Grips™ steering wheel cover and feel the difference a great grip can make.",
              features: [
                "Available in 4 sizes to fit almost any steering wheel.","Helps keep your steering wheel cool in summer and warm in winter.","14 elegant styles to meet the needs of the most discerning driver.","Premium carefully crafted materials to enhance your driving comfort."
              ]
            },
          ]
        },
        {
          title: 'DASHCESSORIES',
          url: '/pages/seat-designs-seat-accessories',
        }
      ]
    );

    const pageInfo = reactive({
      size: 6,
      current: 1,
      list: [1],
      perv: 1,
      next: 2,
    });

    const changeCategory = (index) => {
      current.category = index;
      if(pageData.value[index].url)
      {
        window.location.href=pageData.value[index].url;
      }
      else
      {
        formatPage(pageData.value[index].child.length, true);
      }
    }

    const formatPage = (total, rest) => {
      if (rest) {
        pageInfo.current = 1;
        let totalPage = Math.ceil(total / pageInfo.size);
        pageInfo.list = []
        let page = 1;
        for (page; page <= totalPage; page++) {
          pageInfo.list.push(page);
        }
      }

      pageInfo.perv = Math.max(pageInfo.current - 1, 1);
      pageInfo.next = Math.min(pageInfo.current + 1, Math.max(...pageInfo.list));
    }

    const changePage = (page) => {
      if (page === pageInfo.current) {
        return
      }
      pageInfo.current = page;

      formatPage(0, false);
      goToCategoryScroll()
    }

    const goToCategoryScroll = () => {
      let rect = document.getElementsByClassName("category-handle-box")[0].getBoundingClientRect();

      // 计算要滚动到的位置
      let targetPosition = rect.top + window.scrollY - (isMobile() ? 60 : 10);

      // 滚动到目标位置，使用平滑滚动
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }

    formatPage(pageData.value[current.category].child.length, true);

    return {
      goToCategoryScroll,
      changeCategory,
      formatPage,
      pageInfo,
      changePage,
      current,
      pageData
    }
  }
}).mount('#brand-dash-designs');

$(document).ready(function()
{
  function updateButtonVisibility()
  {
    let container = $('.category-handle');
    let scrollLeft = container.scrollLeft();
    let scrollWidth = container[0].scrollWidth;
    let containerWidth = container.width();

    if (scrollLeft <= 0) {
      $('.category-handle-box .fa-chevron-left').hide();
    } else {
      $('.category-handle-box .fa-chevron-left').css({display:'flex'});
    }

    if (scrollLeft + containerWidth >= scrollWidth) {
      $('.category-handle-box .fa-chevron-right').hide();
    } else {
      $('.category-handle-box .fa-chevron-right').css({display:'flex'});
    }
  }

  $('.category-handle-box .fa-solid').on('click', function () {
    let container = $('.category-handle');
    let containerWidth = container.width();

    let newScrollLeft;

    if($(this).hasClass('fa-solid fa-chevron-right'))
    {
      newScrollLeft = container.scrollLeft() + containerWidth;
    }
    else
    {
      newScrollLeft = Math.max(container.scrollLeft() - containerWidth, 0);
    }

    container.animate({ scrollLeft: newScrollLeft }, 500, updateButtonVisibility);

  });

  $('.category-handle').on('scroll', function(){
    updateButtonVisibility();
  })
});
